module.exports = __webpack_public_path__ + "static/media/tf.29185343.webp";